<div class="shipping-info">
    @if (isValidAddress() === false) {
        <lib-alert-message
            aria-live="assertive"
            role="alert"
            type="error"
            [ariaLabel]="labels().notValidAddress"
            [text]="labels().notValidAddress"
        ></lib-alert-message>
    }
    @let addr = address();
    @if (addr) {
        <div class="shipping-info__section">
            <p class="shipping-info__section-address subheading-1 no-wrap">
                Address
                <mat-icon
                    #tooltip1="matTooltip"
                    matTooltipPosition="right"
                    matTooltipTouchGestures="on"
                    svgIcon="ico_info"
                    tabindex="0"
                    [ariaLabel]="addressTooltip"
                    [attr.aria-hidden]="false"
                    [matTooltip]="addressTooltip"
                    (click)="tooltip1.toggle()"
                />
            </p>

            <p class="body-0">
                @if (name()?.firstName || name()?.lastName) {
                    {{ name()?.firstName | appCapitalFirstLetter }} {{ name()?.lastName | appCapitalFirstLetter }}<br />
                }
                @if (addr.addressLine1) {
                    <span>{{ addr.addressLine1 | appCapitalFirstLetter }}</span
                    ><br />
                }
                @if (addr.addressLine2) {
                    <span>{{ addr.addressLine2 | appCapitalFirstLetter }}</span
                    ><br />
                }
                @if (addr.addressLine3) {
                    <span>{{ addr.addressLine3 | appCapitalFirstLetter }}</span
                    ><br />
                }
                @if (addr.city) {
                    <span>{{ addr.city | appCapitalFirstLetter }}</span
                    >,
                }
                @if (addr.state) {
                    <span>{{ addr.state }}</span
                    >,
                }
                @if (addr.postalCode) {
                    <span>{{ addr.postalCode | postalcode }}</span>
                }
                @if (addr.countryCode && addr.countryCode !== 'USA') {
                    <div>{{ addr.countryCode }}</div>
                }
            </p>
            @if (email()) {
                <p class="subheading-1 no-wrap">Email</p>
                <p class="body-0">{{ email() }}</p>
            }

            <p class="subheading-1 no-wrap">Phone number</p>
            <p class="body-0">{{ userPhone() | appFormatUserPhone }}</p>
        </div>
    } @else {
        <div class="shipping-info__section--skeleton">
            <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
        </div>
    }
</div>
